import { SlabImgContextType } from './slabImg.types';

import { createTypeSafeContext } from '~/core/utils';

const [useSlabImgContext, SlabImgContext] =
  createTypeSafeContext<SlabImgContextType>({
    element: new Image(),
    url: '',
  });

export { useSlabImgContext, SlabImgContext };
